import { render, staticRenderFns } from "./TruckComp.vue?vue&type=template&id=204011a7"
import script from "./TruckComp.vue?vue&type=script&setup=true&lang=js"
export * from "./TruckComp.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TruckComp.vue?vue&type=style&index=0&id=204011a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports